"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ComponentWithPartials = _interopRequireDefault(require("../mixins/ComponentWithPartials"));

var _PageConstants = require("./PageConstants");

var _UIAbstractPageTemplate = _interopRequireDefault(require("./UIAbstractPageTemplate"));

var _UIMain = _interopRequireDefault(require("../layout/UIMain"));

var _UIScrollingColumn = _interopRequireDefault(require("../layout/UIScrollingColumn"));

var CustomRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _sizes = require("HubStyleTokens/sizes");

var _ShareScrollElement = _interopRequireDefault(require("../decorators/ShareScrollElement"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 100%;\n  padding: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MainInnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIEditorPage__MainInnerWrapper",
  componentId: "jnim3-0"
})(_templateObject(), function (props) {
  return !props.mainSectionFlush && props.hasScrolling && _sizes.LAYOUT_EDITOR_PADDING;
});

var UIEditorPage = _react.default.createClass({
  displayName: "UIEditorPage",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    children: _react.PropTypes.node,
    hasScrolling: _react.PropTypes.bool.isRequired,
    headerComponent: CustomRenderer.propType,
    mainBackgroundColor: _react.PropTypes.string,
    mainSectionFlush: _react.PropTypes.bool,
    mainSectionStyle: _react.PropTypes.object,
    Overhang: _UIScrollingColumn.default.propTypes.Overhang,
    pageLayout: _react.PropTypes.oneOf(Object.keys(_PageConstants.LAYOUT_CLASSES)),
    scrollDirection: _UIScrollingColumn.default.propTypes.scrollDirection,
    scrollElementRef: _refObject.default.isRequired,
    sidebarScrollElementRef: _refObject.default,
    sidebarBackgroundColor: _react.PropTypes.string,
    sidebarComponent: CustomRenderer.propType,
    tabs: _react.PropTypes.node,
    title: _react.PropTypes.node,
    use: _react.PropTypes.oneOf(['default', 'dark'])
  },
  getDefaultProps: function getDefaultProps() {
    return {
      hasScrolling: true,
      mainSectionFlush: false,
      sidebarBackgroundColor: _PageConstants.CARD_BACKGROUND,
      scrollDirection: _UIScrollingColumn.default.defaultProps.scrollDirection
    };
  },
  renderEditorSidebar: function renderEditorSidebar(sidebarComponent, sidebarBackgroundColor, sidebarScrollElementRef, hasScrolling) {
    if (!sidebarComponent) return null;
    var RenderedSidebar = hasScrolling ? _UIScrollingColumn.default : 'div';
    var scrollableProps = hasScrolling ? {
      scrollElementRef: sidebarScrollElementRef
    } : null;
    return _react.default.createElement(RenderedSidebar, (0, _extends2.default)({}, scrollableProps, {
      className: "private-editor__sidebar",
      style: {
        backgroundColor: sidebarBackgroundColor
      }
    }), CustomRenderer.render(sidebarComponent));
  },
  renderEditorMain: function renderEditorMain(mainSectionFlush, hasScrolling, Overhang, scrollDirection, scrollElementRef, sidebarBackgroundColor, sidebarScrollElementRef, mainSectionRendererProps) {
    var children = mainSectionRendererProps.children,
        mainSectionBackgroundColor = mainSectionRendererProps.mainSectionBackgroundColor,
        mainSectionStyle = mainSectionRendererProps.mainSectionStyle,
        sidebarComponent = mainSectionRendererProps.sidebarComponent;
    var RenderedMain = hasScrolling ? _UIScrollingColumn.default : _UIMain.default;
    var computedFlush = hasScrolling ? true : mainSectionFlush;
    var scrollableProps = hasScrolling ? {
      Overhang: Overhang,
      role: 'main',
      scrollDirection: scrollDirection,
      scrollElementRef: scrollElementRef
    } : null;
    return _react.default.createElement("div", {
      className: "private-editor__inner"
    }, this.renderEditorSidebar(sidebarComponent, sidebarBackgroundColor, sidebarScrollElementRef, hasScrolling), _react.default.createElement("div", {
      className: (0, _classNames.default)('private-editor__canvas', {
        'private-editor__canvas--flush': computedFlush
      }),
      style: (0, _extends2.default)({}, {
        backgroundColor: mainSectionBackgroundColor
      }, mainSectionStyle)
    }, _react.default.createElement(RenderedMain, (0, _extends2.default)({
      className: "private-editor__main",
      flush: true
    }, scrollableProps), _react.default.createElement(MainInnerWrapper, {
      hasScrolling: hasScrolling,
      mainSectionFlush: mainSectionFlush
    }, children))));
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        hasScrolling = _this$props.hasScrolling,
        headerComponent = _this$props.headerComponent,
        mainBackgroundColor = _this$props.mainBackgroundColor,
        mainSectionFlush = _this$props.mainSectionFlush,
        mainSectionStyle = _this$props.mainSectionStyle,
        Overhang = _this$props.Overhang,
        scrollDirection = _this$props.scrollDirection,
        scrollElementRef = _this$props.scrollElementRef,
        sidebarBackgroundColor = _this$props.sidebarBackgroundColor,
        sidebarComponent = _this$props.sidebarComponent,
        sidebarScrollElementRef = _this$props.sidebarScrollElementRef,
        tabs = _this$props.tabs,
        title = _this$props.title,
        use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "hasScrolling", "headerComponent", "mainBackgroundColor", "mainSectionFlush", "mainSectionStyle", "Overhang", "scrollDirection", "scrollElementRef", "sidebarBackgroundColor", "sidebarComponent", "sidebarScrollElementRef", "tabs", "title", "use"]);
    var mainPanelBackgroundColor = use === 'dark' ? _PageConstants.CARD_BACKGROUND : mainBackgroundColor;
    var mainRenderer = this.partial(this.renderEditorMain, mainSectionFlush, hasScrolling, Overhang, scrollDirection, scrollElementRef, sidebarBackgroundColor, sidebarScrollElementRef);
    return _react.default.createElement(_UIAbstractPageTemplate.default, (0, _extends2.default)({}, rest, {
      bodyClassName: "space-sword--editor",
      className: (0, _classNames.default)('private-editor', className),
      contentAreaFlush: true,
      headerComponent: headerComponent,
      horizontalDivider: true,
      MainSection: mainRenderer,
      mainSectionBackgroundColor: mainPanelBackgroundColor,
      mainSectionStyle: mainSectionStyle,
      pageLayout: "full-width",
      sidebarComponent: sidebarComponent,
      tabs: tabs,
      title: title
    }), children);
  }
});

var _default = (0, _ShareScrollElement.default)(UIEditorPage);

exports.default = _default;
module.exports = exports.default;